// PATH: src/utils/cloudinaryUpload.js
// VERSION: 1.0 — Subida unsigned a Cloudinary (auto: image/video)

export async function uploadToCloudinary(file, { folder } = {}) {
  const cloud = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const preset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  if (!cloud || !preset) {
    throw new Error(
      'Faltan variables REACT_APP_CLOUDINARY_CLOUD_NAME o REACT_APP_CLOUDINARY_UPLOAD_PRESET'
    );
  }

  const url = `https://api.cloudinary.com/v1_1/${cloud}/auto/upload`;
  const fd = new FormData();
  fd.append('file', file);
  fd.append('upload_preset', preset);
  if (folder) fd.append('folder', folder);

  const res = await fetch(url, { method: 'POST', body: fd });
  const json = await res.json();
  if (!res.ok || json.error) {
    const msg = json?.error?.message || 'Fallo subiendo a Cloudinary';
    throw new Error(msg);
  }

  return {
    publicId: json.public_id,         // e.g. iglesia/events/abc123
    secureUrl: json.secure_url,       // vista directa
    resourceType: json.resource_type, // "image" | "video" | "raw"
    width: json.width,
    height: json.height,
    format: json.format,
  };
}
